import { Injectable } from '@angular/core';
import { ApiService, UtilService } from 'src/app/shared';
import { QboTokenDto } from './dto/qbo-token.dto';

@Injectable({
  providedIn: 'root',
})
export class QuickBooksOnlineAuthorizationService {
  constructor(private _api: ApiService, private _utilService: UtilService) {}

  getAuthorizationUri(accountingPackageId: number): Promise<QboTokenDto> {
    const url = `AccountingPackage/${accountingPackageId}/QuickbooksOnline/AuthorizationUri`;
    return this._api.get(url);
  }

  getAuthorizationCode(authData: QboTokenDto): Promise<QboTokenDto> {
    let parameters = 'location=1,width=800,height=650';
    parameters += ',left=' + (screen.width - 800) / 2 + ',top=' + (screen.height - 650) / 2;
    const win = window.open(authData.AuthorizationUri, 'connectPopup', parameters);

    const p = new Promise<any>((resolve) => {
      const pollOAuth = setInterval(() => {
        try {
          if (win.document.URL.indexOf('code') != -1) {
            window.clearInterval(pollOAuth);
            win.close();
            const code = this._utilService.getQueryStringParamValue('code', 'string', win.document.URL);
            const realmId = this._utilService.getQueryStringParamValue('realmId', 'string', win.document.URL);
            authData.CompanyId = realmId;
            authData.AuthorizationCode = code;

            this.convertAuthorizationCodeToTokens(authData).then((data) => {
              resolve(data);
            });
          }
        } catch (e) {
          // ignore any errors. accessing win.document throws an error if the domains are not the same.
          // console.log(e);
        }
      }, 200);
    });

    return p;
  }

  convertAuthorizationCodeToTokens(authData: QboTokenDto): Promise<QboTokenDto> {
    return this._api.post(`AccountingPackage/QuickbooksOnline/ConvertAuthorizationCode`, authData);
  }
}
